import { Component } from '@angular/core';

@Component({
  selector: 'mprd-skeleton-internet-level-two',
  templateUrl: './skeleton-internet-level-two.component.html',
})
export class SkeletonInternetLevelTwoComponent {
  constructor() {}
}
